/* eslint-disable no-console, import/prefer-default-export */
import * as changePassword from './change-password';
import * as statusMessages from './status-messages';
import { updateAccount } from './account-api';
import { validate, positionWindowAtFormElement, formatPhone } from '../../utils/form-validation-utils';

const init = () => {
  const changePasswordBtn = document.querySelector('.btn--change-password');
  const changePasswordDiv = document.querySelector('.change-your-password');
  const changePasswordCancelBtn = document.querySelector('.btn--cancel-change-password');
  const form = document.querySelector('.acct-manage-form');
  const submitBtn = form.querySelector('.o-form__submit');
  const errorMsg = document.querySelector('.acct-manage-form-error-message');

  // Format phone number
  document.getElementById('PhoneNumber').value = formatPhone(document.getElementById('PhoneNumber').value);

  changePasswordBtn.addEventListener('click', () => {
    changePasswordDiv.classList.remove('hide');
    changePassword.showChangePasswordModule();
  });

  changePasswordCancelBtn.addEventListener('click', () => {
    changePassword.hideChangePasswordModule();
    changePasswordDiv.classList.add('hide');
  });

  submitBtn.addEventListener('click', (event) => {
    event.preventDefault();
    if (validate(form)) {
      errorMsg.classList.add('hide');
      updateAccount(
        {
          'user-id': window.userId,
          'first-name': document.getElementById('FirstName').value,
          'last-name': document.getElementById('LastName').value,
          address: document.getElementById('Address').value,
          address2: document.getElementById('Address2').value,
          city: document.getElementById('City').value,
          'state-or-province': document.getElementById('StateOrProvince').value,
          'postal-code': document.getElementById('PostalCode').value,
          country: document.getElementById('Country').value,
          'phone-number': formatPhone(document.getElementById('PhoneNumber').value),
        },
        {
          onSuccess: () => {
            statusMessages.setMessage('<h5>Your account has been updated.</h5>');
            statusMessages.showMessage();
          },
          onError: () => {
            errorMsg.classList.remove('hide');
            positionWindowAtFormElement({
              element: errorMsg,
              offset: -233,
            });
          },
        },
      );
    } else {
      positionWindowAtFormElement({
        element: form.querySelectorAll('.ValidationFail')[0],
        offset: -75,
      });
    }
  });
  changePassword.init();
};

export {
  init,
};
/* eslint-enable no-console, import/prefer-default-export */
